import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

const ModalWrapper = ({ className, children, style = {}, onClickOutside }) => {
  const wrapperRef = useRef(null)

  useEffect(() => {
    const handleBackgroundClick = (event) => {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target) &&
        event.target.id !== 'downloadReady' &&
        typeof onClickOutside === 'function'
      ) {
        onClickOutside()
      }
    }

    document.addEventListener('click', handleBackgroundClick, true)
    document.addEventListener('touchstart', handleBackgroundClick, true)

    return () => {
      document.removeEventListener('click', handleBackgroundClick, true)
      document.removeEventListener('touchstart', handleBackgroundClick, true)
    }
  }, [onClickOutside])

  return (
    <div ref={wrapperRef} className={className} style={style}>
      {children}
    </div>
  )
}

ModalWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  style: PropTypes.object,
  onClickOutside: PropTypes.func
}

export default ModalWrapper
